import React, { Component } from "react";

import {
  Card,
  Button,
  Table,
  Tooltip,
  Select,
  Input,
  BackTop,
  Modal,
  Switch,
} from "antd";

import { connect } from "react-redux";
import { req_page_eca_english_course } from "../../api";

import {
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import {
  getNowAcademicYear,
  getNowAcademicSemester,
} from "../../utils/dateUtil";
import memoryUtils from "../../utils/memoryUtils";

import EnglishCourseDetailsModal from "./english-course-details-modal";

class UIEnglishCourse extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "ALL",

    domnloadFile: "",

    nowAcademicYear: getNowAcademicYear(new Date()),
    nowAcademicSemester: getNowAcademicSemester(new Date()),

    isShowModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_page_items(1);
  }

  // componentWillUnmount(){
  //     window.removeEventListener("resize", this.resize.bind(this))
  // }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = (current) => {
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      nowAcademicYear,
      nowAcademicSemester,
    } = this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    //採用(母母視窗模式)
    if (memoryUtils.pagination.isGoBack) {
      const nowAcademicYear = memoryUtils.pagination.academicYear;
      const nowAcademicSemester = memoryUtils.pagination.academicSemester;
      // 標準
      this.current = memoryUtils.pagination.current;
      const pageSize = memoryUtils.pagination.pageSize;
      const columnSort = memoryUtils.pagination.columnSort;
      const orderBy = memoryUtils.pagination.orderBy;
      const searchField = memoryUtils.pagination.searchField;
      const searchValue = memoryUtils.pagination.searchValue;
      const filterStatus = memoryUtils.pagination.filterStatus;
      this.setState(
        {
          nowAcademicYear,
          nowAcademicSemester,
          current,
          pageSize,
          columnSort,
          orderBy,
          searchField,
          searchValue,
          filterStatus,
        },
        () => {
          this.api_page_run(
            userCode,
            userLevel,
            nowAcademicYear,
            nowAcademicSemester,
            current,
            pageSize,
            columnSort,
            orderBy,
            searchField,
            searchValue,
            filterStatus,
            token
          );
        }
      );
    } else {
      this.current = current; // 保存當前頁，給其他方法可看到
      this.api_page_run(
        userCode,
        userLevel,
        nowAcademicYear,
        nowAcademicSemester,
        current,
        pageSize,
        columnSort,
        orderBy,
        searchField,
        searchValue,
        filterStatus,
        token
      );
    }

    if (memoryUtils.pagination.isGoBack) {
      memoryUtils.pagination.isGoBack = false;
    }
  };

  api_page_run = async (
    userCode,
    userLevel,
    nowAcademicYear,
    nowAcademicSemester,
    current,
    pageSize,
    columnSort,
    orderBy,
    searchField,
    searchValue,
    filterStatus,
    token
  ) => {
    this.setState({ loading: true, items: [] });
    const result = await req_page_eca_english_course(
      userCode,
      userLevel,
      nowAcademicYear,
      nowAcademicSemester,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token
    );
    //console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
    this.setState({ loading: false });
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "開課流水號",
        dataIndex: "OpenCourseIdKey",
        width: 30,
        responsive: ["md"],
      },
      {
        title: "學年度",
        dataIndex: "AcademicYear",
        width: 20,
        responsive: ["md"],
      },
      {
        title: "學期",
        dataIndex: "AcademicSemester",
        width: 18,
        responsive: ["md"],
      },
      {
        title: "科目代碼",
        dataIndex: "CourseCode",
        width: 35,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "課程名稱",
        dataIndex: "CourseTwName",
        width: 45,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "開課系所",
        dataIndex: "OpenCourseDepartment",
        width: 55,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.2em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "開課班級",
        dataIndex: "OpenClassroomName",
        width: 40,
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "授課老師",
        dataIndex: "TeacherName",
        width: 40,
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "學生人數",
        dataIndex: "OpenNum",
        width: 30,
        responsive: ["md"],
      },
      {
        title: "",
        dataIndex: "",
        width: 65,
        render: (englishcourse) => {
          const { OpenNum, HitCount } = englishcourse;
          return (
            <>
              <button
                type="button"
                className="btn btn-outline-dark btn-sm"
                onClick={() => this.handle_show_ui_modal("view", englishcourse)}
              >
                <i className="far fa-file-alt"></i>
                <span style={{ marginLeft: "9px" }}>課程詳情</span>
              </button>
              <div></div>
              {OpenNum > 0 ? (
                <button
                  type="button"
                  className={
                    HitCount === 0
                      ? "btn btn-outline-dark btn-sm"
                      : "btn btn-success btn-sm"
                  }
                  onClick={() => this.handle_pages_next_stautus(englishcourse)}
                >
                  <i className="fas fa-user-friends"></i>
                  <span style={{ marginLeft: "2px" }}>學生清單</span>
                </button>
              ) : (
                ""
              )}
            </>
          );
        },
      },
    ];
  };

  style_switch_color_tag(column, param) {
    switch (column) {
      case "NoneTotal":
        break;
      case "NeedOutreachTotal":
        break;
      case "TutorWaitConfirmTotal":
        break;
      default:
        break;
    }
  }
  // 操作互動處理 //////////////////////////////////////////////

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "view":
        this.setState({ isShowModal: true, item });
        break;
      case "edit":
        this.setState({ isEditModal: true, item });
        break;
      case "add":
        this.setState({ isAddModal: true });
        break;
      case "delete":
        const { uid } = item;
        Modal.confirm({
          title: `您確定刪除此筆公告資訊`,
          onOk: () => {
            this.api_delete_item(uid);
          },
        });
        break;
      case "download":
        break;
      default:
    }
  };

  handle_pages_next_stautus = (item) => {
    // memoryUtils.pagination.isGoNext = true
    const {
      nowAcademicYear,
      nowAcademicSemester,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
    } = this.state;
    memoryUtils.pagination.academicYear = nowAcademicYear;
    memoryUtils.pagination.academicSemester = nowAcademicSemester;

    memoryUtils.pagination.current = this.current;
    memoryUtils.pagination.pageSize = pageSize;
    memoryUtils.pagination.columnSort = columnSort;
    memoryUtils.pagination.orderBy = orderBy;
    memoryUtils.pagination.searchField = searchField;
    memoryUtils.pagination.searchValue = searchValue;
    memoryUtils.pagination.filterStatus = filterStatus;

    this.props.history.push("/learnpoints/course/students", item);
  };

  handle_check_changed = () => {
    const tag = this.state.filterStatus;
    const filterStatus = tag === "NOTUPLOADED" ? "ALL" : "NOTUPLOADED";
    this.setState({ filterStatus }, () => {
      this.api_page_items(this.current);
    });
  };

  /////////////////////////////////////////////////////////////

  render() {
    const {
      loading,
      items,
      pagination,
      searchField,
      searchValue,
      nowAcademicYear,
      nowAcademicSemester,
      isShowModal,
      item,
      filterStatus,
    } = this.state;
    const title = (
      <span>
        <Input
          placeholder="學年"
          style={{ width: 55, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={nowAcademicYear}
          onChange={(event) =>
            this.setState({ nowAcademicYear: event.target.value })
          }
        />
        <Input
          placeholder="學期"
          style={{ width: 55, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={nowAcademicSemester}
          onChange={(event) =>
            this.setState({ nowAcademicSemester: event.target.value })
          }
        />
        <Select
          value={searchField}
          style={{ width: 120, backgroundColor: "LightCyan" }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="TeacherName">授課老師姓名</Select.Option>
          <Select.Option value="OpenClassroomName">開課班級</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 80, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}> 查詢</span>
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>
      </span>
    );
    return (
      <Card title={title}>
        <div>
          <Switch
            checkedChildren="顯示未上傳成績課程"
            unCheckedChildren="顯示所有課程"
            defaultChecked={filterStatus === "NOTUPLOADED" ? true : false}
            onClick={this.handle_check_changed}
          />
        </div>
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="OpenCourseIdKey"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
        <Modal
          destroyOnClose={true}
          visible={isShowModal}
          width={1000}
          onOk={() => {
            this.setState({ isShowModal: false });
          }}
          onCancel={() => {
            this.setState({ isShowModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <EnglishCourseDetailsModal course={item} />
        </Modal>
        <BackTop visibilityHeight="80" />
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(UIEnglishCourse);
